export enum AccessibilityAnchorOrientation {
    Top = 1,
    Right,
    Left,
    Bottom,
}

export interface AccessibilityAnchorButtonProps {
    label: string;
    onClick: (ev?: React.MouseEvent) => void;
    backgroundColor?: string;
    key?: string;
    announcementOnClick?: string;
    // determines where the button is relative to the position of the container, left, right , top or bottom
    orientation?: AccessibilityAnchorOrientation;
    // determines the position of the button relative to other anchor buttons on the orientation position
    orientationIndex?: number;
}
